import { Injectable } from '@angular/core';

type ToastPreset = 'error' | 'warning' | 'success' | 'info' | 'custom';
type ToastColor = 'primary' | 'dark' | 'black' | 'gray' | 'green' | 'warn' | 'orange' | 'green';

interface Toast {
  size: 'tiny' | 'small' | 'medium' | 'large';
  title: string;
  message: string;
  icon: string;
  image: string;
  backgroundImage: string;
  backgroundImageSize: number;
  color: ToastColor;
  duration: number;
  closable: boolean;
  vertical: boolean;
  cta?: {
    color: string;
    text: string;
    onClick: Function;
  };
  location: 'head' | 'footer' | 'corner';
}

const defaultToastOptions: Toast = {
  closable: false,
  duration: 2500,
  size: 'small',
  icon: undefined,
  image: undefined,
  backgroundImage: undefined,
  backgroundImageSize: 128,
  color: 'black',
  title: undefined,
  message: undefined,
  location: 'head',
  vertical: false,
};

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts: Toast[] = [];
  presets = {
    error: { icon: '/assets/icons/cross-circle.svg', color: 'warn' },
    warning: { icon: '/assets/icons/alert-circle.svg', color: 'orange' },
    success: { icon: '/assets/icons/check-circle.svg', color: 'green' },
    info: { icon: '/assets/icons/info-circle.svg', color: 'primary' },
  };
  constructor() {}

  add(message: string, preset: ToastPreset, options: Partial<Toast> = {}) {
    let defaultOptions = { ...defaultToastOptions };
    if (options.closable && !options.duration) defaultOptions.duration = undefined;
    if (preset && this.presets[preset]) {
      defaultOptions.icon = this.presets[preset].icon;
      defaultOptions.color = this.presets[preset].color;
    }
    let newToast: Toast = { ...defaultOptions, ...options, message };
    this.toasts.push(newToast);
    if (newToast.duration !== undefined) {
      setTimeout(() => {
        let index = this.toasts.indexOf(newToast);
        if (index > -1) this.toasts.splice(index, 1);
      }, newToast.duration);
    }
    return newToast;
  }

  public close(toast: Toast) {
    let index = this.toasts.indexOf(toast);
    if (index > -1) this.toasts.splice(index, 1);
  }
}
